import { render, staticRenderFns } from "./HomeBetCreatorNew.vue?vue&type=template&id=76d189f6&scoped=true&"
import script from "./HomeBetCreatorNew.vue?vue&type=script&lang=js&"
export * from "./HomeBetCreatorNew.vue?vue&type=script&lang=js&"
import style0 from "./HomeBetCreatorNew.vue?vue&type=style&index=0&id=76d189f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d189f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76d189f6')) {
      api.createRecord('76d189f6', component.options)
    } else {
      api.reload('76d189f6', component.options)
    }
    module.hot.accept("./HomeBetCreatorNew.vue?vue&type=template&id=76d189f6&scoped=true&", function () {
      api.rerender('76d189f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/HomeBetCreatorNew.vue"
export default component.exports